import { useEffect, useState } from "react";
import palestineLogo from "../assets/palestine-logo.svg";

import { Row } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import Particles from "react-tsparticles";
import particles_params from "../constants/particles-params";

import Translations from "../translations";
import getTranslatedText from "../helpers/getTranslatedText";

var timeOfInvasion = new Date(1948, 5, 15).getTime();
var durationTillNow = new Date() - timeOfInvasion;
const MS_IN_DAY = 1000 * 60 * 60 * 24;
const daysTillNow = durationTillNow / MS_IN_DAY;
const years = parseInt(daysTillNow / 365);
const months = parseInt((daysTillNow - years * 365) / 30);
const days = parseInt(daysTillNow - (30 * months + 365 * years));

function Home({ totalMessages }) {
  // const [messages, setMessages] = useState(totalMessages);
  // const [currentIndex, setCurrentIndex] = useState(0);
  // const [tempPause, setTempPause] = useState(false);

  // useEffect(() => {
  //   setMessages(totalMessages);
  // }, [totalMessages]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (messages.length && !tempPause) {
  //       setCurrentIndex((prev) => (prev >= messages.length - 1 ? 0 : prev + 1));
  //     } else {
  //       setTempPause(false);
  //     }
  //   }, 4000);

  //   return () => clearInterval(interval);
  // }, [messages, tempPause]);

  const { id, lang } = useParams();
  // useEffect(() => {
  //   if (id) {
  //     const index = messages.findIndex((message) => message._id === id);
  //     index > -1 &&
  //       setCurrentIndex(messages.findIndex((message) => message._id === id));
  //     setTempPause(true);
  //   }
  // }, [id, messages]);

  // function isEnglish(content) {
  //   return /[a-z]/gi.test(content);
  // }

  return (
    <>
      <Particles id="particles-js" params={particles_params} />

      <div>
        <center>
          <img id="logo" src={palestineLogo} alt="palestine" />
        </center>
      </div>

      <div className="infoSection" id="infoSection">
        <h1>{getTranslatedText(Translations, "title", lang)}</h1>

        {/* <div>
          {messages.length ? (
            <>
              <h3
                id="message"
                style={{
                  direction:
                    isEnglish(messages[currentIndex]?.content) ? 'ltr':"rtl",
                }}
              >
                {messages[currentIndex]?.content}
              </h3>
              <h5 id="from">{messages[currentIndex]?.name}</h5>
            </>
          ) : (
            getTranslatedText(Translations, "loading", lang)
          )}
        </div> */}
        <div id="FooterSection">
          <span id="occupationDataSection">
            {/* {messages.length ? (
              <Row id="counter" justify="center" align="middle">
                <LeftOutlined
                  role="button"
                  className="counter_icons pulseAnimation"
                  onClick={() => {
                    if (currentIndex > 0) {
                      setTempPause(true);
                      setCurrentIndex((prev) => prev - 1);
                    }
                  }}
                />
                <span>
                  {currentIndex + 1}/{messages.length}
                </span>
                <RightOutlined
                  className="counter_icons pulseAnimation"
                  onClick={() => {
                    if (currentIndex < messages.length - 1) {
                      setTempPause(true);
                      setCurrentIndex((prev) => prev + 1);
                    }
                  }}
                />
              </Row>
            ) : null} */}

            <h3>
              {getTranslatedText(Translations, "occupationDurationText", lang)}
            </h3>
            <h3 id="timer" style={{ direction: lang === "ar" ? "rtl" : "ltr" }}>
              {years} {getTranslatedText(Translations, "years", lang)}, {months}{" "}
              {getTranslatedText(Translations, "months", lang)}, {days}{" "}
              {getTranslatedText(Translations, "days", lang)}
            </h3>
          </span>
          <Row justify="space-around">
            {/* <Link to={`/${lang}/create-message`} className="messageBtn">
              {getTranslatedText(Translations, "createMessageButton", lang)}
            </Link>
            <Link to={`/${lang}/messageCards`} className="messageBtn">
              {getTranslatedText(Translations, "messagesButton", lang)}
            </Link> */}
            <Link to={`/${lang}/boycott`} className="messageBtn">
              {getTranslatedText(Translations, "boycottButton", lang)}
            </Link>
            <Link to={`/${lang}/departments`} className="messageBtn">
              {getTranslatedText(Translations, "departmentsButton", lang)}
            </Link>
          </Row>
        </div>
      </div>
    </>
  );
}

export default Home;
